module.exports = __webpack_public_path__ + "img/image5.47f29892.webp";